module.exports = __webpack_public_path__ + "img/switzerland-pregnancy-childbirth-and-the-puerperium-female.2fee1e11.png";